import CookieNotification from './CookieNotification';

export default CookieNotification;
